import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { CategoriesDataService } from '@community-settings/core/services/categories-data.service';
import { Category } from '@sb-tools/typescript/models/category.model';
import { CategoriesService } from '@core/services/categories.service';

@Injectable()
export class CurrentCategoryResolver implements Resolve<Category> {
    constructor(
        private categoriesDataService: CategoriesDataService,
        private categoriesService: CategoriesService,
    ) {}

    resolve(route: ActivatedRouteSnapshot): Observable<Category> {
        const id = route.paramMap.get('categoryId');

        // Vova: Need to hide data of previous category when new category is loading
        this.categoriesService.currentCategory.next(null);

        return this.categoriesDataService.getCategoryById(+id).pipe(
            map((category: Category) => {
                this.categoriesService.currentCategory.next(category);
                return category;
            }),
        );
    }
}
